export type LegalSection = {
  heading: string
  paragraphs: string[]
}

export type LegalDocument = {
  id: 'privacidad' | 'terminos'
  label: string
  title: string
  updated: string
  intro: string
  sections: LegalSection[]
}

export const legalDocuments: LegalDocument[] = [
  {
    id: 'privacidad',
    label: 'Política de Privacidad',
    title: 'Política de Privacidad',
    updated: 'Última actualización: agosto 2026',
    intro:
      'Esta política explica qué datos recopilamos cuando compras el Método Vientre Plano 21D, con qué finalidad los usamos y cómo los protegemos.',
    sections: [
      {
        heading: 'Datos que recopilamos',
        paragraphs: [
          'Recopilamos únicamente los datos necesarios para procesar tu compra y entregarte el material digital: nombre, correo electrónico y los datos de facturación que solicita la plataforma de pago.',
          'No almacenamos los datos completos de tu tarjeta. El cobro se realiza directamente en la pasarela de pago, que opera bajo estándares de seguridad de nivel bancario.',
        ],
      },
      {
        heading: 'Cómo usamos tu información',
        paragraphs: [
          'Usamos tu correo electrónico para enviarte el acceso a la guía, los recursos incluidos en el bundle y las instrucciones de descarga.',
          'También podemos enviarte contenido educativo relacionado con el método. Puedes darte de baja en cualquier momento desde el enlace incluido al final de cada correo.',
        ],
      },
      {
        heading: 'Cookies y medición',
        paragraphs: [
          'Utilizamos cookies propias y de terceros para medir el rendimiento de esta página y entender qué contenido resulta más útil. Puedes bloquearlas desde la configuración de tu navegador sin perder acceso al material comprado.',
        ],
      },
      {
        heading: 'Conservación y seguridad',
        paragraphs: [
          'Conservamos tus datos mientras mantengas acceso al producto o mientras exista una obligación legal o tributaria que lo requiera. La información se transmite cifrada y el acceso está restringido al equipo responsable de la entrega.',
        ],
      },
      {
        heading: 'Tus derechos',
        paragraphs: [
          'Puedes solicitar el acceso, la rectificación o la eliminación de tus datos personales, así como retirar tu consentimiento para las comunicaciones comerciales. Las solicitudes se atienden a través del mismo canal por el que recibiste tu compra.',
        ],
      },
      {
        heading: 'Cambios en esta política',
        paragraphs: [
          'Si actualizamos esta política, publicaremos la nueva versión en esta misma página indicando la fecha de la última modificación.',
        ],
      },
    ],
  },
  {
    id: 'terminos',
    label: 'Términos y Condiciones',
    title: 'Términos y Condiciones',
    updated: 'Última actualización: agosto 2026',
    intro:
      'Al comprar el Método Vientre Plano 21D aceptas los términos descritos a continuación. Te recomendamos leerlos antes de completar tu pago.',
    sections: [
      {
        heading: 'Qué incluye el producto',
        paragraphs: [
          'El producto es un bundle 100% digital compuesto por la Guía Maestra en PDF, el Calendario de Ruta, la Lista de Compras Anti-Inflamatoria, el Protocolo SOS y la Guía de Suplementación Estratégica.',
          'No incluye acompañamiento personalizado, consultas individuales, productos físicos ni suplementos.',
        ],
      },
      {
        heading: 'Entrega y acceso',
        paragraphs: [
          'El acceso se entrega de forma inmediata después de confirmarse el pago. Es tu responsabilidad ingresar un correo electrónico válido y revisar la carpeta de spam si no ves el mensaje de entrega.',
        ],
      },
      {
        heading: 'Precio y pagos',
        paragraphs: [
          'Los valores se expresan en pesos chilenos (CLP). El precio de lanzamiento es una promoción por tiempo limitado y puede cambiar sin aviso previo; el valor aplicable es el vigente al momento de completar la compra.',
        ],
      },
      {
        heading: 'Uso del material y propiedad intelectual',
        paragraphs: [
          'La compra te otorga una licencia personal e intransferible de uso. No está permitido copiar, revender, distribuir, compartir en grupos ni reproducir total o parcialmente el contenido sin autorización escrita.',
        ],
      },
      {
        heading: 'Aviso de salud',
        paragraphs: [
          'El contenido tiene fines educativos e informativos y no constituye un diagnóstico, tratamiento ni indicación médica. No sustituye la evaluación de un profesional de la salud.',
          'Si estás embarazada, en período de lactancia, bajo tratamiento médico o con una condición diagnosticada, consulta a tu profesional de salud antes de aplicar el protocolo.',
        ],
      },
      {
        heading: 'Resultados',
        paragraphs: [
          'Los resultados descritos corresponden a reportes de usuarias y pueden variar según hábitos, adherencia al protocolo y condiciones individuales. No garantizamos resultados específicos.',
        ],
      },
      {
        heading: 'Devoluciones',
        paragraphs: [
          'Por tratarse de un producto digital de descarga inmediata, la compra no admite devolución una vez entregado el acceso, salvo en casos de error de cobro duplicado o falla técnica que impida acceder al material.',
        ],
      },
    ],
  },
]
